module.exports = "/assets/ecs/lno/ecs-lno-frontend-concierge/3.6.2/_next/static/images/icon-apple-store-ab77576578140a44009c8308550264db.webp";